import { InputHTMLAttributes, forwardRef } from 'react'
import clsx from 'clsx'

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string
  error?: string
  helperText?: string
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, error, helperText, className, ...props }, ref) => {
    return (
      <div className="w-full">
        <div className="flex items-start">
          <div className="flex items-center h-5">
            <input
              ref={ref}
              type="checkbox"
              className={clsx(
                'w-4 h-4 rounded transition-colors',
                'border-gray-300 text-primary-600',
                'focus:ring-2 focus:ring-primary-500 focus:ring-offset-0',
                props.disabled && 'bg-gray-50 cursor-not-allowed',
                className
              )}
              {...props}
            />
          </div>

          {label && (
            <div className="ml-3">
              <label className="text-sm font-medium text-gray-700">
                {label}
              </label>
              {helperText && !error && (
                <p className="text-sm text-gray-500">{helperText}</p>
              )}
            </div>
          )}
        </div>

        {error && (
          <p className="mt-1 text-sm text-red-600">{error}</p>
        )}
      </div>
    )
  }
)

Checkbox.displayName = 'Checkbox'
